<template>
    <svg
        height="512"
        viewBox="0 0 512 512"
        width="512"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
    >
        <path d="m323.07 216a93.16 93.16 0 0 0 -67.07 29.23 93.17 93.17 0 0 0 -67.07-29.23c-42.93 0-77.93 35.63-77.93 79.42a118.22 118.22 0 0 0 2.43 24.22c9.1 43.62 35.88 82.65 77.44 112.88 30.9 22.48 59.09 32.27 60.27 32.67a15 15 0 0 0 9.72 0c1.18-.4 29.37-10.19 60.27-32.67 41.56-30.23 68.34-69.26 77.43-112.86a117.86 117.86 0 0 0 2.44-24.24c0-43.79-35-79.42-77.93-79.42z" />
        <path d="m510.64 54.78a15 15 0 0 0 -19.87-7.42 565.11 565.11 0 0 1 -469.54 0 15 15 0 1 0 -12.45 27.29 595.15 595.15 0 0 0 232.22 53.59v49.28a74.59 74.59 0 0 0 -26.8 11.24 123.7 123.7 0 0 1 41.8 17.6 123.75 123.75 0 0 1 41.79-17.61 74.77 74.77 0 0 0 -26.79-11.23v-49.28a595.23 595.23 0 0 0 232.23-53.59 15 15 0 0 0 7.41-19.87z" />
    </svg>
</template>
